import { PopupState } from "material-ui-popup-state/hooks";
import { createContext } from "react";

const ProgramsFoldersButtonContext = createContext<PopupState | undefined>(
  undefined,
);

export default ProgramsFoldersButtonContext;
